<template>
  <UiModal
    :show="showHistory"
    title="竞猜记录"
    iconType="quiz_1"
    :empty="!quizList_ || quizList_.length === 0"
    @close="close"
    size="lg"
  >
    <div class="history-box">
      <ul class="quizList">
        <li
          v-for="(type, key) in quizType"
          :key="key"
          :class="{ active: subType === type.id }"
          @click="switchType(type.id)"
        >
          <UiLabel>{{ type.name }}</UiLabel>
        </li>
      </ul>

      <div class="inner">
        <div class="switch-source-slot">
          <UiSelect :list="navList" :selected-id="subNav" @switch="switchNav" hook="px" />
        </div>
        <div class="history">
          <ul class="history-list" v-if="quizList_ && quizList_.length !== 0">
            <li v-for="(history, key) in quizList_" :key="key">
              <div class="header">
                <div class="title">
                  <UiLabel shadow-color="#FFFFFF" text-color="#513718">{{ history.title }}</UiLabel>
                </div>
                <div class="date">
                  <UiLabel shadow-color="#FFFFFF" text-color="#513718">{{ formatDay(history.scheduleCode) }}</UiLabel>
                </div>
              </div>
              <div class="des">
                <div
                  v-for="(item, i) in getDesItems(history)"
                  :key="i"
                  :class="item.className"
                >
                  {{ item.label }}：<span>{{ item.value }}</span>
                </div>
              </div>
              <div class="status" :class="[`status-${history.status}`]"></div>
            </li>
          </ul>
          <UiEmpty v-else class="data-none" tip="暂无竞猜记录" hook="px" />
        </div>
      </div>
    </div>
  </UiModal>
</template>

<script setup>
import lg from '@/utils/lg'
import { ref, computed, watch } from "vue";
import { useAppStore } from '@/store'
import { useModal } from '@/composables/useModal'
import * as api from "@/service/index";
import { usePrompt } from '@/composables/usePrompt';
import UiModal from "@/components/ui-modal.vue";
import UiLabel from "@/components/ui-label";
import UiSelect from "@/components/ui-select";
import UiEmpty from "@/components/ui-empty";

const appStore = useAppStore()

const showHistory = ref(false);
const { close } = useModal('quiz-history', showHistory, {
  onOpen() { fetchHistory() }
})
const navList = ref([
  { id: "", name: "全部记录" },
  { id: 0, name: "待开奖" },
  { id: 1, name: "中奖" },
  { id: 2, name: "未中奖" },
]);
const subNav = ref("");
const subType = ref(1);
const quizType = ref([
  { id: 1, name: "赛程竞猜" },
  { id: 2, name: "实时竞猜" },
  { id: 3, name: "排名PK" },
  { id: 4, name: "淘汰PK" },
]);
const quizList = ref([]);
const dateZh = ref(["日", "一", "二", "三", "四", "五", "六"]);
const matchZh = ref(["", "一", "二", "三", "四", "五", "六", "七", "八", "九"]);
const subSeasonID = ref('');

const token = computed(() => appStore.token)
const schedule = computed(() => appStore.schedule)
const seasonInfo = computed(() => appStore.seasonInfo)
const quizList_ = computed(() => {
  if (subNav.value !== "") {
    return quizList.value.filter((item) => {
      if (subNav.value === 1) {
        // 当 type 为 1 并且 subNav 为 1 时，返回 status 为 1 或 3 的项目
        return (item.status === 1 || item.status === 3) && item.type === subType.value;
      }  else {
        return item.status === subNav.value && item.type === subType.value;
      }
    })
  } else {
    return quizList.value.filter((item) => item.type === subType.value);
  }
});

// 模板 ref
const { showPrompt } = usePrompt();

async function fetchHistory() {
  if(!token.value) return;
  let data = {
    token: token.value,
    seasonId: subSeasonID.value
  };
  let response = await api.reqQuizList(data);
  if (response.status === 200) {
    quizList.value = response.data;
  } else {
    showPrompt(response.data);
  }
}
function getDesItems(history) {
  const noMatch = lg(history, 'matchCode', 0) === 0
  const items = [
    { label: '预测',     value: history.quizAnswer,                                                              className: 'quiz' },
    { label: '竞猜结果', value: lg(history, 'realAnswer', []).map(a => a?.answer).filter(Boolean).join(',') || '-', className: noMatch ? 'answer normal' : 'answer' },
    { label: '局数',     value: `第${matchZh.value[Number(history.matchCode)] || ''}局`, show: !noMatch,         className: 'match' },
    { label: '赔率',     value: history.lossRate,                                                                className: 'odds' },
    { label: '投注',     value: history.goldNum,                                                                 className: 'betting' },
    { label: '猜中可得', value: Math.round(history.goldNum * history.lossRate),                                  className: 'amount-get' },
  ]
  return items.filter(item => item.show !== false)
}
function switchNav(navID) {
  subNav.value = navID;
}
function switchType(typeID) {
  subType.value = typeID;
}
function formatDay(scheduleCode) {
  if (schedule.value && schedule.value.length !== 0) {
    const schedule_ = schedule.value.find(
      (item) => item.scheduleCode === scheduleCode
    );
    if (!schedule_) return "";
    let startAt = new Date(schedule_.startAt);
    let month = startAt.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    let day = startAt.getDate();
    day = day < 10 ? "0" + day : day;

    return `${month}月${day}日 周${dateZh.value[startAt.getDay()]} ${
      schedule_.name
    }`;
  } else {
    return "";
  }
}
watch(
  seasonInfo,
  (newVal) => {
    if(newVal && newVal.id) {
      subSeasonID.value = newVal.id;
    }
  },
  { immediate: true, deep: true }
);

</script>

<style lang="scss" scoped>
.history-box {
  position: relative;
  display: flex;
  padding: 96px 54px 40px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  .quizList {
    width: 128px;
    height: 234px;
    position: relative;
    flex: none;
    align-self: flex-start;
    margin-top: 4px;
    margin-right: 30px;
    background: url(https://website.xdcdn.net/poster/58881/26match/common/QZtIYi32.png) center/contain no-repeat;
    filter: drop-shadow(0 2px 4px rgba(#000, 0.2));
    font-size: 24px;
    // 未选中态字色 (承接原 blue-light 变体字色)
    --label-shadow-color: #C20306;
    --label-text-color: #fff;

    li {
        position: relative;
        isolation: isolate;
        width: 100%;
        height: 58px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        // 底部分隔线
        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 3px;
          width: 116px;
          height: 2px;
          background-color: #A70E11;
        }

        // 选中态叠加背景 (承接原 .bg-active ui-button colorType="yellow")
        &::before {
          content: '';
          position: absolute;
          top: 7.5px;
          left: -12px;
          width: 146px;
          height: 47px;
          background: url(https://website.xdcdn.net/poster/58881/26match/common/QZuvNtgk.png) center/contain no-repeat;
          opacity: 0;
          transition: opacity ease-in-out 100ms;
          z-index: -1;
          pointer-events: none;
        }

        &:last-child::after {
          display: none;
        }

        &.active {
          // 选中字色 (承接原 yellow 变体字色)
          --label-shadow-color: #{rgba(#fff, 0.7)};
          --label-text-color: #513718;
          &::after { display: none; }
          &::before { opacity: 1; }
        }
      }
    }

  .inner {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .switch-source-slot {
      align-self: flex-end;
      width: 155px;
      height: 40px;
      flex: none;
      margin-bottom: 8px;

      :deep(.ui-select-panel) {
        width: 155px;
        overflow: auto;
      }

      @include hideScrollBar();
    }

    .history {
      position: relative;
      height: calc(100% - 48px);
      overflow: hidden scroll;
      @include hideScrollBar();

      .history-list {
        li {
          position: relative;
          overflow: hidden;
          height: 170px;
          margin-bottom: 20px;
          background-image: url(https://website.xdcdn.net/poster/58881/26match/common/QZvxR97x.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;

          > .header {
            height: 60px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
              margin-left: 12px;
              font-size: 24px;
            }

            .date {
              margin-right: 16px;
              font-size: 20px;
            }
          }

          .des {
            width: 648px;
            height: 110px;
            box-sizing: border-box;
            font-size: 20px;
            color: #A60E11;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            align-items: center;
            margin-left: 15px;
            padding: 12px 0 16px;

            > div {
              min-height: 40px;
              line-height: 32px;
              display: flex;
              align-items: center;
            }

            .match.hide {
              opacity: 0;
            }

            span {
              color: #761114;
            }

            .answer.normal {
              grid-column: span 2;
            }
          }

          .status {
            $icon-wait: url(https://website.xdcdn.net/poster/58881/26match/icon/QZvAY30a.png);
            $icon-fail: url(https://website.xdcdn.net/poster/58881/26match/icon/QZvAYh77.png);
            $icon-win: url(https://website.xdcdn.net/poster/58881/26match/icon/QZvAYdp4.png);
            &.status-0 {
              background-image: $icon-wait;
            }
            &.status-1,
            &.status-3 {
              background-image: $icon-win;
            }
            &.status-2 {
              background-image: $icon-fail;
            }

            width: 100px !important;
            height: 100px !important;
            position: absolute;
            bottom: 7px;
            right: 46px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            transform: rotate(30deg);
          }

          &:last-of-type {
            margin-bottom: 0;
          }
        }
      }

      p {
        width: 100%;
        position: absolute;
        top: 40%;
        text-align: center;
        font-size: 16px;
        color: $gray-99;
      }
    }

    ::-webkit-scrollbar {
      display: block !important;
    }
  }
}
</style>
